import { render } from "./Contact.vue?vue&type=template&id=54dc4f76"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=54dc4f76&lang=css"
script.render = render

export default script